import S3 from 'react-aws-s3';
import { Aws_S3_Bucket_info } from '../components/common/constants';

 export  const ReactS3ClientConfig = {
    bucketName: Aws_S3_Bucket_info.name,
    // dirName: 'media', /* optional */
    region: Aws_S3_Bucket_info.region,
    accessKeyId: Aws_S3_Bucket_info.AWSAccessKey,
    secretAccessKey: Aws_S3_Bucket_info.AWSSecretKey,
    // s3Url: 'https:/your-custom-s3-url.com/', /* optional */
}

window.Buffer = window.Buffer || require("buffer").Buffer;
Buffer.from('anything','base64');

 const ReactS3Client = new S3(ReactS3ClientConfig);
/*  Notice that if you don't provide a dirName, the file will be automatically uploaded to the root of your bucket */

/* This is optional */
// const newFileName = 'test-file';

// ReactS3Client
//     .uploadFile(file, newFileName)
//     .then(data => console.log(data))
//     .catch(err => console.error(err))

  /**
   * {
   *   Response: {
   *     bucket: "myBucket",
   *     key: "image/test-image.jpg",
   *     location: "https://myBucket.s3.amazonaws.com/media/test-file.jpg"
   *   }
   * }
   */

   export default ReactS3Client;

